import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  BillOfMaterialsListItem,
  BillOfMaterialsStatus,
} from "./bill-of-materials-types";

const SearchBillOfMaterialsInput_ = z.object({
  search: z.string().optional(),
  status: BillOfMaterialsStatus.optional(),
  tags: z.array(z.string()).optional(),
  /** Advanced filters from the list page (status, BOM tags, product tags). */
  advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).max(1500).optional(),
  sortField: createEnum([
    "name",
    "createdAt",
    "inputCount",
    "outputCount",
  ]).optional(),
  sortDirection: createEnum(["asc", "desc"]).optional(),
});
export const SearchBillOfMaterialsInput: z.ZodType<SearchBillOfMaterialsInput> =
  SearchBillOfMaterialsInput_;
export interface SearchBillOfMaterialsInput
  extends z.infer<typeof SearchBillOfMaterialsInput_> {}

const SearchBillOfMaterialsOutput_ = z.object({
  items: z.array(BillOfMaterialsListItem),
  totalCount: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
});
export const SearchBillOfMaterialsOutput: z.ZodType<SearchBillOfMaterialsOutput> =
  SearchBillOfMaterialsOutput_;
export interface SearchBillOfMaterialsOutput
  extends z.infer<typeof SearchBillOfMaterialsOutput_> {}

export const searchBillOfMaterials = {
  name: "searchBillOfMaterials" as const,
  input: SearchBillOfMaterialsInput,
  output: SearchBillOfMaterialsOutput,
};
